import * as yup from 'yup';
import { insightsFormValidationShape } from './insightsFieldsConfig';

export const quoteComparisonSchema = yup
  .object()
  .shape({
    ...insightsFormValidationShape,
  })
  .required();
